// @TODO: move this file to the rootDir
import { storeRoutes } from '@lingoda/store';
import { subscriptionRoutes } from '@lingoda/membership';
import type { RouteConfigExtended } from '@lingoda/router';
import { leadConversionFlowRoutes } from '@lingoda/lead-conversion-flow';
import { getStartedRoutes, onboardingRoutes } from '@lingoda/student-onboarding';
import { freeTrialPurchaseRoutes } from '@lingoda/free-trial-purchase';
import { emailVerificationRoutes } from '@lingoda/email-verification';
import { packagePurchaseRoutes } from '@lingoda/package-purchase';
import { postCheckoutAppRoutes } from '../post-checkout';
import { routes as errorRoutes } from '../errors/routes';
import { MainPageFrame } from '../root/MainPageFrame/lazy';
import publicRoutes from './public';
import studentRoutes from './student';

const routes: RouteConfigExtended[] = [
    {
        component: MainPageFrame,
        label: 'Main',
        routes: [
            ...publicRoutes,
            ...emailVerificationRoutes,
            ...studentRoutes,
            ...leadConversionFlowRoutes,
            ...onboardingRoutes,
            ...postCheckoutAppRoutes,
            ...getStartedRoutes,
            ...storeRoutes,
            ...subscriptionRoutes,
            ...freeTrialPurchaseRoutes,
            ...packagePurchaseRoutes,
            ...errorRoutes,
        ],
        config: undefined,
    },
];

export default routes;
